// https://redux.js.org/api/store
/*
observeStore(
  store,
  (state) => state.profile,
  (nextProfile) => {
    // do something
  },
);
*/
export function observeStore(store, select, onChange) {
  let currentState;

  function handleChange() {
    const nextState = select(store.getState());
    if (nextState !== currentState) {
      currentState = nextState;
      onChange(currentState);
    }
  }

  const unsubscribe = store.subscribe(handleChange);
  handleChange();
  return unsubscribe;
}
